module.exports = __webpack_public_path__ + "static/media/icon-star-outline.f73d8ce8.svg";